import { createContext, useContext, useState, useEffect } from 'react';
import { applyDocumentLang, detectLanguage, isSupportedLanguage } from '../locales/languages';
import { setActiveLanguage } from '../locales/index';

const LanguageContext = createContext();

function initLanguage() {
  const lang = detectLanguage();
  setActiveLanguage(lang);
  applyDocumentLang(lang);
  return lang;
}

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(initLanguage);

  useEffect(() => {
    if (!isSupportedLanguage(language)) {
      setLanguage('en');
      return;
    }
    setActiveLanguage(language);
    applyDocumentLang(language);
    try {
      localStorage.setItem('language', language);
    } catch (_) {
      /* ignore */
    }
  }, [language]);

  const changeLanguage = (newLanguage) => {
    if (isSupportedLanguage(newLanguage)) setLanguage(newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
